"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var EventBindingEditor = /** @class */ (function (_super) {
    __extends(EventBindingEditor, _super);
    function EventBindingEditor(props) {
        return _super.call(this, props) || this;
    }
    EventBindingEditor.prototype.getPriorityAvail = function () {
        var _ret = [];
        for (var i = 1; i <= 10; i++) {
            _ret.push({
                key: i,
                value: "\u041D\u043E\u043C\u0435\u0440-" + i,
            });
        }
        return _ret;
    };
    EventBindingEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    player_level_title: _item.player_level_title,
                    player_level_id: _item.player_level_id,
                    is_player_level: _item.is_player_level,
                    title: _item.title,
                    event_type_code: _item.event_type_code,
                    event_type_title: _item.event_type_title,
                    is_locked: _item.is_locked,
                    is_show_bonus_description: _item.is_show_bonus_description,
                    _brands: [],
                    _bonus_templates: [],
                    _app_currency: [],
                    _event_types: [],
                    _player_levels: [],
                    order_number_key: _item.order_number,
                    order_number_val: "\u041D\u043E\u043C\u0435\u0440-" + _item.order_number,
                    order_number_avail: this.getPriorityAvail(),
                    description: _item.description
                }, function () {
                    _this.props.listPlayerLevels.LoadData(_this.state.brand_id);
                    _this.props.state.setExtBreadCrumbPath(["Редактирование события"]);
                });
            }
        }
        else {
            this.setState({
                brand_id: 0,
                brand_title: "",
                event_type_code: 0,
                event_type_title: "",
                is_player_level: false,
                player_level_id: 0,
                player_level_title: "",
                is_locked: false,
                is_show_bonus_description: false,
                title: "",
                _bonus_templates: [],
                _brands: [],
                _app_currency: [],
                _event_types: [],
                _player_levels: [],
                order_number_key: 1,
                order_number_val: "\u041D\u043E\u043C\u0435\u0440-" + 1,
                order_number_avail: this.getPriorityAvail(),
                description: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание события"]);
            });
        }
        this.SID_LAC = this.props.listAppCurrency.Subscribe("*", function (id, data) {
            _this.setState({
                _app_currency: data.data
            });
        });
        this.SID_LBR = this.props.listBrands.Subscribe("*", function (id, data) {
            _this.setState({
                _brands: data.data
            });
        });
        this.SID_LET = this.props.listBonusEvents.Subscribe("*", function (id, data) {
            _this.setState({
                _event_types: data.data
            });
        });
        this.SID_LPL = this.props.listPlayerLevels.Subscribe("*", function (id, data) {
            _this.setState({
                _player_levels: data.data
            });
        });
        this.props.listAppCurrency.LoadData();
        this.props.listBrands.LoadData();
        this.props.listBonusEvents.LoadData();
        this.doReSetRules();
    };
    EventBindingEditor.prototype.componentWillUnmount = function () {
        this.props.listAppCurrency.UnSubscribe(this.SID_LAC);
        this.props.listBrands.UnSubscribe(this.SID_LBR);
        this.props.listBonusEvents.UnSubscribe(this.SID_LET);
        this.props.listPlayerLevels.UnSubscribe(this.SID_LPL);
    };
    EventBindingEditor.prototype.doReSetRules = function () {
        this.setState({
            brand_rules: { isError: false },
            event_type_rules: { isError: false },
            player_level_rules: { isError: false },
            title_rules: { isError: false },
            order_number_rules: { isError: false }
        });
    };
    EventBindingEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({ brand_rules: { isError: true, errorMessage: "Поле [бренд] не выбрано!" } });
            return false;
        }
        if ((this.state.order_number_key <= 0) || (this.state.order_number_val.length === 0)) {
            this.setState({ order_number_rules: { isError: true, errorMessage: "Поле [Порядковый номер] не выбрано!" } });
            return false;
        }
        if ((this.state.event_type_code <= 0) || (this.state.event_type_title.length === 0)) {
            this.setState({ event_type_rules: { isError: true, errorMessage: "Поле [тип события] не выбрано!" } });
            return false;
        }
        if (this.state.is_player_level) {
            if ((this.state.player_level_id <= 0) || (this.state.player_level_title.length === 0)) {
                this.setState({ player_level_rules: { isError: true, errorMessage: "Поле [Уровень пользователя] не выбрано!" } });
                return false;
            }
        }
        if ((this.state.title == "") || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        return true;
    };
    EventBindingEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                title: this.state.title,
                is_player_level: this.state.is_player_level,
                player_level_id: this.state.player_level_id,
                is_locked: this.state.is_locked,
                is_show_bonus_description: this.state.is_show_bonus_description,
                order_number: this.state.order_number_key,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Обработчик события изменен!");
            });
        }
    };
    EventBindingEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                player_level_id: this.state.player_level_id,
                brand_id: this.state.brand_id,
                title: this.state.title,
                event_type_code: this.state.event_type_code,
                is_player_level: this.state.is_player_level,
                is_locked: this.state.is_locked,
                is_show_bonus_description: this.state.is_show_bonus_description,
                order_number: this.state.order_number_key,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Обработчик события добавлен!");
            });
        }
    };
    EventBindingEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    EventBindingEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить обработчик события";
        }
        else {
            return "Изменить обработчик события";
        }
    };
    EventBindingEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 630 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Выберите бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false }
                    }, function () {
                        _this.props.listPlayerLevels.LoadData(_this.state.brand_id);
                        _this.setState({ player_level_id: 0, player_level_title: "" });
                    });
                }, items: this.state._brands, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Порядковый номер:", placeholder: "Выберите порядковый номер" }, value: { key: this.state.order_number_key, value: this.state.order_number_val }, onValueChanged: function (newVal) {
                    _this.setState({
                        order_number_key: newVal.key,
                        order_number_val: newVal.value,
                        order_number_rules: { isError: false }
                    });
                }, items: this.state.order_number_avail, required: true, rules: this.state.order_number_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип события:", placeholder: "Выберите тип события" }, value: { key: this.state.event_type_code, value: this.state.event_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        event_type_code: newVal.key,
                        event_type_title: newVal.value,
                        event_type_rules: { isError: false }
                    });
                }, items: this.state._event_types, required: true, rules: this.state.event_type_rules, disabled: this.props.record != null }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Для выбранного уровня пользователя", value: this.state.is_player_level, onChecked: function (checked) { _this.setState({ is_player_level: checked }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Уровень пользователя:", placeholder: "Выберите уровень пользователя" }, value: { key: this.state.player_level_id, value: this.state.player_level_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        player_level_id: newVal.key,
                        player_level_title: newVal.value,
                        player_level_rules: { isError: false }
                    });
                }, items: this.state._player_levels, required: true, rules: this.state.player_level_rules, disabled: !this.state.is_player_level }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Комментарий:", placeholder: "Введите комментарий" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal,
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Обработчик события заблокирован", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Отображается описание бонуса", value: this.state.is_show_bonus_description, onChecked: function (checked) { _this.setState({ is_show_bonus_description: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return EventBindingEditor;
}(React.Component));
exports.default = EventBindingEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_events_bindings/ui/component/EventBindingEditor.tsx
// module id = 1979
// module chunks = 0